export default __webpack_public_path__ + "static/media/profile-picture-1.e783b80f.jpg";